import React, { useState, useEffect } from 'react';
import {useDispatch, useSelector} from "react-redux";
import {closePopup} from "../../../actions/popup";
import {jsonResponseHandler} from "../../../utils/FetchHelper"
import {addPrefix} from "../../../utils/UriUtil";
import {ARCHIVE, DEFAULT} from "../../../constants/design/SkinTypes"
import {TISTORY} from "../../../constants/Service"


function SkinDetailTitle({skin, type}) {

  const title = type === DEFAULT? skin.title : skin.archiveName

  let category = ''
  if (typeof skin.layout != 'undefined') {
    if (skin.layout == 'responsive') {
      category = '반응형'
    } else if (skin.layout == 'etc') {
      category = '기타'
    } else {
      category = `${skin.layout}단형`
    }
  } else {
    if (skin.archiveType == ARCHIVE) {
      category = '보관'
    } else {
      category = '업로드'
    }
  }
  return (
    <strong className="tit_popup">
      {title}
      <span className="txt_cate">{category}</span>
    </strong>
  )
}

function SkinDetailPreviewImage({skinInfo, type}) {
  if (type !== DEFAULT) {
    return null
  }

  return (
    <div className="wrap_thumb">
      <img src={ skinInfo.preview1600 } width="800" height="600" className="thumb_img" alt="" />
    </div>
  )
}

function SkinDetailDescription({skinInfo}) {
  return (
    <div className="info_skin">
      <p className="txt_popup">{skinInfo.description}</p>

      {window.Config.service === TISTORY &&
        <>
          <dl className="list_skin">
            <dt>제작자</dt>
            <dd>{skinInfo.author.name} ({skinInfo.author.homepage}) <span className="txt_other">{skinInfo.author.email}</span></dd>
          </dl>
          <dl className="list_skin">
            <dt>저작권</dt>
            <dd>{skinInfo.license}</dd>
          </dl>
        </>
      }
    </div>
  )
}

export default function SkinDetailPopup({setSkin}) {
  const [initialized, setInitialized] = useState(false)
  const [skinInfo, setSkinInfo] = useState(null)
  const [type, setType] = useState(null)
  const [top, setTop] = useState('150px')

  const skin = useSelector(state => state.popup.skin)
  const isSkinDetailPopupOpened = useSelector(state => state.popup.isSkinDetailPopupOpened)
  const dispatch = useDispatch()

  function handlePopupClose() {
    dispatch(closePopup())
  }

  function handlePreview(e) {
    window.open(addPrefix(`/manage/previewSkin.php?skin=${skin.skinName}&mark=true`), '_blank');
  }

  function applySkin(e) {
    setSkinInfo(null)
    setInitialized(false)

    handlePopupClose();
    setSkin(typeof skin.skinName != 'undefined'?skin.skinName:'customize/'+skin.folderName);
  }

  useEffect(() => {
    const innerLayer = document.getElementsByClassName('inner_blog_layer4')[0];
    if (typeof innerLayer != 'undefined' && document.documentElement.clientHeight > innerLayer.scrollHeight + 140) {
      if (top != (document.documentElement.clientHeight-innerLayer.scrollHeight)/2+'px')
        setTop((document.documentElement.clientHeight-innerLayer.scrollHeight)/2+'px')
    } else {
      if (top != '50px')
        setTop('50px')
    }
  })

  useEffect(() => {
    if (!isSkinDetailPopupOpened) {
      setSkinInfo(null)
      setInitialized(false)
      return
    }

    if (!skin) {
      return
    }

    if (typeof skin.skinName != 'undefined') {
      fetch(addPrefix(`/manage/design/skin/detail.json?name=`) + skin.skinName, {
        credentials: 'include',
      })
        .then(jsonResponseHandler(dispatch))
        .then(r => r.json())
        .then(data => {
          setSkinInfo(data.skinInfo)
          setInitialized(true)
          setType(DEFAULT)
        })
        .catch(e => {
          console.error(e)
          alert("문제가 발생했습니다.")
        })
    } else {
      fetch(addPrefix(`/manage/design/skin/archiveDetail.json?name=`) + skin.folderName, {
        credentials: 'include',
      })
        .then(jsonResponseHandler(dispatch))
        .then(r => r.json())
        .then(data => {
          setSkinInfo(data.skinInfo)
          setInitialized(true)
          setType(ARCHIVE)
        })
        .catch(e => {
          console.error(e)
          alert("문제가 발생했습니다.")
        })
    }
  }, [isSkinDetailPopupOpened])


  if (!isSkinDetailPopupOpened || !initialized) {
    return null
  }

  return (
    <div className="blog_layer" style={{top: top}}>
      <div className="inner_blog_layer inner_blog_layer4">
        <div className="cont_layer">
          <SkinDetailTitle skin={skin} type={type} />
          <SkinDetailPreviewImage skinInfo={skinInfo} type={type} />
          <SkinDetailDescription skinInfo={skinInfo} />

          <div className="etc_skin">
            {skinInfo.useBlogmenu &&(
              <a href={addPrefix("/manage/design/menu")} target="_blank" className="link_etc">메뉴설정</a>
            )}
            {skinInfo.useWizard &&(
              <a href={addPrefix('/admin/skin/wizard/?skin='+skin.skinName)} className="link_etc">스킨위자드</a>
            )}

            <div className="skin_btn">
              {type == DEFAULT && (
                <button type="button" className="btn_preview" onClick={e => handlePreview(e)}>미리보기<span className="ico_blog">새창으로 열기</span></button>
              )}
              <button type="button" className="btn_save" onClick={e => applySkin(e)}>적용</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
